console.log('footer.js');

document.addEventListener('DOMContentLoaded', function() {
  var thbWidget = document.querySelectorAll('.footer .row .thb-widget-parents');
  var contactUs = document.querySelector('.contact-us')

  

  thbWidget.forEach((el)=>{
    var thbTielt = el.querySelector('.thb-widget-title')


    function thAuto() {
      var thbMenu = el.querySelector('.thb-widget-menu')
      var thbIcon = el.querySelector('.thb-widget-icon')

      thbMenu.classList.toggle('thb-menu-down')
      thbIcon.classList.toggle('thb-widget-icon-deg')
    }
    thAuto()
    thbTielt.addEventListener('click',()=>{
      
      thAuto()
    })

  })

  contactUsFunction()
  
  function contactUsFunction() {
    var usIcon = contactUs.querySelector('.thb-widget-icon')
    var usMenu = contactUs.querySelector('.rte')

    usMenu.classList.toggle('thb-menu-down')
    usIcon.classList.toggle('thb-widget-icon-deg')
  }

  contactUs.addEventListener('click',()=>{
    contactUsFunction()
    

  })
 
});

// document.addEventListener('DOMContentLoaded', function() {
//   var thbWidget = document.querySelectorAll('.footer .row .thb-widget-parents');
//   var contactUs = document.querySelector('.contact-us');

//   // 封装 contactUs 的点击事件处理函数
//   function handleContactUsClick() {
//     var usIcon = contactUs.querySelector('.thb-widget-icon');
//     var usMenu = contactUs.querySelector('.rte');

//     usMenu.classList.toggle('thb-menu-down');
//     usIcon.classList.toggle('thb-widget-icon-deg');
//   }

//   // 初始化时执行一次 contactUs 点击事件处理函数
//   handleContactUsClick();

//   thbWidget.forEach((el)=>{
//     var thbTielt = el.querySelector('.thb-widget-title');

//     function thAuto() {
//       var thbMenu = el.querySelector('.thb-widget-menu');
//       var thbIcon = el.querySelector('.thb-widget-icon');

//       thbMenu.classList.toggle('thb-menu-down');
//       thbIcon.classList.toggle('thb-widget-icon-deg');
//     }

//     // 初始化时执行一次 thAuto 函数
//     thAuto();

//     thbTielt.addEventListener('click', () => {
//       thAuto();
//     });
//   });

//   // 添加 contactUs 点击事件监听器
//   contactUs.addEventListener('click', handleContactUsClick);
// });
